import React, { useMemo, useEffect, useState } from "react"
import {
  Container,
  CardBody,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Table,
} from "reactstrap"
import practice_logo from "../../assets/images/users/profile.png"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"
import * as XLSX from "xlsx"

const EmployeeDailyReport = () => {
  const [table_data, settable_data] = useState([])
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [logsModal, setLogsModal] = useState(false)
  const [selectedLogs, setSelectedLogs] = useState([])
  const [employees, setEmployees] = useState([])
  const [workTypes, setWorkTypes] = useState([])
  const [filter, setFilter] = useState({
    employeeId: "",
    workTypeId: "",
    filterdDate: moment().format("YYYY-MM-DD"),
  })
  const [tempFilter, setTempFilter] = useState({
    employeeId: "",
    workTypeId: "",
    filterdDate: moment().format("YYYY-MM-DD"),
  })

  const toggleModal = () => {
    setModal(!modal)
    if (!modal) {
      setTempFilter(filter)
    }
  }

  const toggleLogsModal = () => setLogsModal(!logsModal)

  const getLogs = async filters => {
    try {
      setLoading(true)
      const response = await axiosbaseurl.post(
        `/reports/employee/daily/report`,
        {
          employeeId: filters.employeeId || null,
          workTypeId: filters.workTypeId || null,
          filterdDate: filters.filterdDate,
        }
      )
      if (response.data.success) {
        if (filters.workTypeId || filters.filterdDate) {
          settable_data(
            response.data.report?.map(item => ({
              ...item,
              workType: workTypes.find(w => w.id == filters.workTypeId)
                ?.workType,
              date: moment(filters.filterdDate).format("DD/MM/YYYY"),
              day: moment(filters.filterdDate).format("dddd"),
            }))
          )

          return
        }

        settable_data(
          response.data.report?.map(log => ({
            ...log,
            date: moment().format("DD/MM/YYYY"),
            day: moment().format("dddd"),
          }))
        )
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const getEmployees = async () => {
      try {
        const response = await axiosbaseurl.get("/employee-master/active")
        if (response.data.success) {
          setEmployees(response.data.data)
        }
      } catch (error) {
        console.log(error)
      }
    }

    const getWorkTypes = async () => {
      try {
        const response = await axiosbaseurl.get("/work-type/active")
        if (response.data.success) {
          setWorkTypes(response.data.data)
        }
      } catch (error) {
        console.log(error)
      }
    }

    getLogs(filter)
    getEmployees()
    getWorkTypes()
  }, [])

  // Billiable and scheduled
  // Billiable and Non-scheduled
  // Non-Billiable and scheduled
  // Non-Billiable and Non-scheduled

  const handleFilterChange = e => {
    const { name, value } = e.target
    setTempFilter(prev => ({ ...prev, [name]: value }))
  }

  const applyFilters = () => {
    setFilter(tempFilter)
    getLogs(tempFilter)
    toggleModal()
  }

  const resetFilters = () => {
    const defaultFilter = {
      employeeId: "",
      workTypeId: "",
      filterdDate: moment().format("YYYY-MM-DD"),
    }
    setTempFilter(defaultFilter)
    setFilter(defaultFilter)
    getLogs(defaultFilter)
    toggleModal()
  }

  const exportToExcel = () => {
    const exportData = table_data.map(item => ({
      Date: item.date,
      Day: item.day,
      "Employee Name": item?.employeeName,
      "Working Hours": item.workedHours,
      "Idle Hours": item.idleHours,
      "Extra Hours": item.extraHours,
      "Expected Hours": item.expectedHours,
    }))

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, `Daily Report`)

    const maxWidths = Object.keys(exportData[0] || {}).map(key => ({
      wch: Math.max(
        key.length,
        ...exportData.map(item => String(item[key]).length)
      ),
    }))
    worksheet["!cols"] = maxWidths

    XLSX.writeFileXLSX(
      workbook,
      `Employee_Daily_Report_${moment().format("DD_MM_YYYY_hh_mm_ss")}.xlsx`
    )
  }

  document.title = "Daily Report | Peacock Accountants Limited"

  return (
    <>
      {loading && <Loader />}

      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Daily Report"} />

          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent
                table_data={table_data}
                exportToExcel={exportToExcel}
                toggleModal={toggleModal}
                toggleLogsModal={toggleLogsModal}
                setSelectedLogs={setSelectedLogs}
              />
            </CardBody>
          </Card>

          <Modal isOpen={modal} toggle={toggleModal} centered={true}>
            <ModalHeader toggle={toggleModal}>Filter Daily Report</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup row>
                  <Label for="employeeId" sm={4}>
                    Employee
                  </Label>
                  <Col sm={8}>
                    <Input
                      type="select"
                      name="employeeId"
                      id="employeeId"
                      value={tempFilter.employeeId}
                      onChange={handleFilterChange}
                    >
                      <option value="">All Employees</option>
                      {employees.map(employee => (
                        <option key={employee.id} value={employee.id}>
                          {employee.name} {employee.lastName}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="workTypeId" sm={4}>
                    Work Type
                  </Label>
                  <Col sm={8}>
                    <Input
                      type="select"
                      name="workTypeId"
                      id="workTypeId"
                      value={tempFilter.workTypeId}
                      onChange={handleFilterChange}
                    >
                      <option value="">All Work Types</option>
                      {workTypes.map(workType => (
                        <option key={workType.id} value={workType.id}>
                          {workType.workType}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="filterdDate" sm={4}>
                    Date
                  </Label>
                  <Col sm={8}>
                    <Input
                      type="date"
                      name="filterdDate"
                      id="filterdDate"
                      value={tempFilter.filterdDate}
                      onChange={handleFilterChange}
                    />
                  </Col>
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={applyFilters}>
                Apply Filters
              </Button>
              <Button color="secondary" onClick={resetFilters}>
                Reset
              </Button>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={logsModal}
            toggle={toggleLogsModal}
            size="xl"
            centered={true}
          >
            <ModalHeader toggle={toggleLogsModal}>Daily Logs</ModalHeader>
            <ModalBody>
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {selectedLogs.length === 0 ? (
                  <p className="text-center">
                    No logs available for this employee.
                  </p>
                ) : (
                  <Table className="table-bordered">
                    <thead>
                      <tr className="bg-primary text-white">
                        <th>#</th>
                        <th>Client Code</th>
                        <th>Task Name</th>
                        <th>Service</th>
                        <th>Work Type</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Worked On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedLogs.map((log, index) => (
                        <tr key={log.id}>
                          <td>{index + 1}</td>
                          <td>
                            {log.task?.client?.clientCode ||
                              log?.client?.clientCode ||
                              "N/A"}
                          </td>
                          <td>{log.task?.title || log?.title || "N/A"}</td>
                          <td>
                            {log.task?.serviceName?.serviceName ||
                              log?.service?.serviceName ||
                              "N/A"}
                          </td>
                          <td>{log.workType?.workType || "N/A"}</td>
                          <td>{log.startTime || "N/A"}</td>
                          <td>{log.endTime || "N/A"}</td>
                          <td>
                            {moment(log.createdAt).format("DD/MM/YY") || "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({
  table_data,
  exportToExcel,
  toggleModal,
  toggleLogsModal,
  setSelectedLogs,
}) => {
  const { checkAccess } = usePermissionData()
  const module_id = 24
  const navigate = useNavigate()

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "employeeId",
        filterable: true,
        disableFilters: true,
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Day",
        accessor: "day",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Employee",
        accessor: "employeeName",
        disableFilters: true,
        filterable: true,
        className: "col-2",
        Cell: cellProps => {
          return (
            <div className="d-flex align-items-center">
              <div className="text-center employee-margin-right">
                <img
                  src={
                    cellProps.row.original?.employeePhoto
                      ? `${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original?.employeePhoto}`
                      : practice_logo
                  }
                  alt="img"
                  className="rounded-circle"
                  width={35}
                  height={35}
                />
              </div>
              <div>{cellProps.row.original?.employeeName}</div>
            </div>
          )
        },
      },
      ...(table_data[0]?.workType
        ? [
            {
              Header: "Work Type",
              accessor: "workType",
              disableFilters: true,
              className: " text-center",
            },
          ]
        : []),
      {
        Header: "Worked Hours",
        accessor: "workedHours",
        disableFilters: true,
        className: " text-center",
      },
      {
        Header: "Idle Hours",
        accessor: "idleHours",
        disableFilters: true,
        className: " text-center",
      },
      {
        Header: "Extra Hours",
        accessor: "extraHours",
        disableFilters: true,
        className: "text-center",
      },
      {
        Header: "Logs",
        accessor: "dailyLogs",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <div className="d-flex justify-content-center">
            <button
              title="View Logs"
              className="btn btn-info bg-info btn-sm"
              onClick={() => {
                // console.log("dailyLogs:", cellProps.row.original.dailyLogs)
                setSelectedLogs(cellProps.row.original.dailyLogs || []) // Fallback to empty array
                toggleLogsModal()
              }}
            >
              <i className="fas fa-list"></i>
            </button>
          </div>
        ),
      },
    ],
    [table_data]
  )

  const data = useMemo(() => {
    return table_data
  }, [table_data])

  return (
    <PermittedComponent isAccess={checkAccess(module_id, "view")}>
      <CommonTable
        columns={columns}
        data={data}
        heading={
          <>
            <div>{`Daily Report`}</div>
          </>
        }
      >
        <div className="d-flex">
          <div>
            <button
              onClick={toggleModal}
              className="btn btn-outline-primary ms-3"
            >
              <i className="fas fa-filter me-3"></i>
              Filter
            </button>
          </div>
          <div>
            <button
              onClick={exportToExcel}
              className="btn btn-primary bg-primary ms-3"
            >
              <i className="fas fa-download me-3"></i>
              Export
            </button>
          </div>
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </div>
      </CommonTable>
    </PermittedComponent>
  )
}

export default EmployeeDailyReport
